import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from 'app/menu/models/menu.model';
import { MenuService } from './../../services/menu.service';

@Component({
    selector: 'app-recommend',
    templateUrl: './recommend.component.html',
    styleUrls: ['./recommend.component.scss'],
    standalone: false
})
export class RecommendComponent implements OnInit {
  /**
   * Informacion del menu para sacar colores y tipo de fuente
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Identificador del idioma
   */
  lang = 'ES';
  /**
   * Indica si de debe mostrar o no el label
   */
  showLabel = true;
  /**
   * Identificador de color de texto
   */
  color = '#000000';
  constructor(
    private router: Router,
    private menuService: MenuService
  ) { }

  ngOnInit(): void {
    this.menuService.getLang().subscribe((r: string) => {
      this.lang = r;
    });
    this.validateRoute();
    this.color = this.menu.colorText;
    this.validateColor();
  }

  /**
   * Indica si se debe de visualizar el label o no
   * solo se visualizara si estamos en el detalle de menu
   */
  private validateRoute(): void {
    const isDetail = this.router.url.indexOf('menu-detail');
    if (isDetail !== -1) {
      this.showLabel = true;
    } else {
      this.showLabel = false;
    }
  }


  /**
   * Valida si el color del texto es blanco, lo coloca en negro
   * para garantizar que el contenido se vea en el card
   */
  private validateColor(): void {
    if (this.menu.colorText === '#ffffff' && this.showLabel) {
      this.color = '#000000';
    }
  }

}
